import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const SOCIALS = [
  { href: "https://www.instagram.com/berulia_/", label: "Instagram", Icon: Instagram, external: true },
];

const COLUMNS = [
  {
    title: "Boutique",
    links: [
      { to: "/boutique", label: "Toutes les pièces" },
      { to: "/categorie/nouveautes", label: "Nouveautés" },
      { to: "/categorie/robes", label: "Robes" },
      { to: "/categorie/accessoires", label: "Accessoires" },
    ],
  },
  {
    title: "Service client",
    links: [
      { to: "/mon-compte", label: "Mon compte" },
      { to: "/politique-retour", label: "Livraisons & retours" },
      { href: "mailto:contact@berulia.fr", label: "contact@berulia.fr" },
    ],
  },
  {
    title: "Informations légales",
    links: [
      { to: "/mentions-legales", label: "Mentions légales" },
      { to: "/cgv", label: "CGV" },
    ],
  },
];

const LinkItem = ({ to, href, label }) => (
  <li>
    {to
      ? <Link to={to} className="hover:text-berulia-rosedeep">{label}</Link>
      : <a href={href} className="hover:text-berulia-rosedeep">{label}</a>}
  </li>
);

export default function Footer() {
  return (
    <footer className="mt-24 bg-gradient-to-b from-berulia-cream to-berulia-rose/30 text-berulia-inkdeep border-t border-berulia-border">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <p className="font-heading font-serif-italic text-3xl text-berulia-rosedeep">BERULIA</p>
          <p className="mt-3 text-sm text-berulia-inkmuted leading-relaxed">
            Prêt-à-porter féminin — pièces choisies, livraison soignée.
          </p>
          <div className="mt-5 flex items-center gap-3">
            {SOCIALS.map(({ href, label, Icon }) => href ? (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-berulia-rosedeep/40 text-berulia-rosedeep hover:bg-berulia-rosedeep hover:text-white transition"
              >
                <Icon size={16}/>
              </a>
            ) : (
              <span
                key={label}
                aria-label={label}
                title={label}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-berulia-border text-berulia-inkmuted/60 cursor-not-allowed"
              >
                <Icon width={16} height={16}/>
              </span>
            ))}
          </div>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.title}>
            <p className="overline text-berulia-rosedeep mb-4">{col.title}</p>
            <ul className="space-y-2 text-sm">
              {col.links.map((l) => <LinkItem key={l.label} {...l} />)}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-berulia-rosedeep/20">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-berulia-inkmuted">
          <p>© {new Date().getFullYear()} BERULIA — <span className="font-serif-italic">prêt-à-porter féminin</span></p>
          <p>Paiement sécurisé · Livraison Colissimo & Mondial Relay</p>
          <a
            href="https://wedreamteam.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-wedreamteam"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-berulia-rosedeep/40 text-berulia-rosedeep hover:bg-berulia-rosedeep hover:text-white transition"
          >
            Site fait par <span className="font-semibold">WeDreamTeam</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
